import React from 'react';
import { ForwardCurve } from '@components';

const TheForwardCurve = () => {
    return (
        <ForwardCurve
            title="THE Forward Curve"
            rootPath="/static/files/csv/index/forward_curve/the/"
            breadcrumbRootLabel="the-forward-curve"
            searchPlaceholders={{
                0: 'Search year folder (e.g. 2026)',
                1: 'Search month folder (e.g. 03 or March)',
                2: 'Search filename (e.g. ttf_da_index.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Year',
                1: 'Month',
                2: 'File',
                default: 'Folder'
            }}
        />
    );
};

export default TheForwardCurve;
